import EditDeviceModal from './EditDeviceModal';

export default EditDeviceModal;
